/** Default landing page after sign-in. */
export const POST_LOGIN_PAGE = "explore-ideas";

export function postLoginPath(_credits, { isNewAccount = false } = {}) {
  if (isNewAccount) {
    return `/user?page=${POST_LOGIN_PAGE}&welcome=1`;
  }
  return `/user?page=${POST_LOGIN_PAGE}`;
}

export function safeCheckoutReturn(value) {
  const path = String(value || "").trim();
  return /^\/checkout\/[0-9a-f]{8}-[0-9a-f-]{27}$/i.test(path) ? path : null;
}

/**
 * Store token and navigate using live credit balance from get_me.
 * @param {{ token: string, hitAxios: Function, history: any, isNewAccount?: boolean }} args
 */
export async function completeUserAuth({
  token,
  hitAxios,
  history,
  isNewAccount = false,
  returnTo = null,
}) {
  localStorage.setItem(process.env.REACT_APP_TOKEN + "_user", token);
  const checkoutReturn = safeCheckoutReturn(returnTo);

  try {
    const res = await hitAxios({
      path: "/api/user/get_me",
      post: false,
      admin: false,
      showLoading: false,
      showSnackbar: false,
    });
    if (res?.data?.success) {
      if (checkoutReturn) {
        history.replace(checkoutReturn);
        return;
      }
      if (!res.data.data?.has_paid_plan) {
        history.replace("/pricing");
        return;
      }
      history.push(postLoginPath(res.data.data?.credits, { isNewAccount }));
      return;
    }
  } catch {
    /* fall through */
  }

  history.replace(checkoutReturn || "/pricing");
}
